import type { FormDataOf } from '../../../../../types/templates';
import { disneyEspnVS } from '..';
import { leagueRequiresRound } from './league-config';

type FormData = FormDataOf<typeof disneyEspnVS>;

export const cleanFormData = (formData: FormData): Record<string, unknown> => {
  const { title: _title, ...rest } = formData as FormData & { _creativityType?: string };
  const config: Record<string, unknown> = { ...rest };
  delete config._creativityType;

  if (!config.time4 || !config.enableRegion4) {
    delete config.region4;
    delete config.time4;
  }

  delete config.enableRegion4;
  delete config.autoSyncTimes;

  if (!leagueRequiresRound(config.league as string)) {
    delete config.round;
  }

  return config;
};
